import type { FC } from 'react';

import { Button } from '@mui/material';

import { useOnboardingDialogStore } from 'features/onboarding/lib/useOnboardingDialogStore';

// Floating launcher for the assistant chat, in the bottom-right corner. Below the dialog's z-index
// so it tucks behind the chat once opened.
export const AssistantLauncherButton: FC = () => {
  const open = useOnboardingDialogStore((state) => state.open);
  return (
    <Button
      variant="contained"
      onClick={open}
      startIcon={<img src="/favicon.svg" alt="" className="h-5 w-5 rounded" />}
      sx={{
        position: 'fixed',
        right: 24,
        bottom: 24,
        zIndex: 1200,
        borderRadius: 999,
        textTransform: 'none',
        boxShadow: 3,
      }}
    >
      Ask Truv AI
    </Button>
  );
};
